// Vocation Works brand mark — adopted 2026-09-14, replaces the old "V in a box".
//
// Two opposing corner brackets framing a solid amber block. The geometry is fixed on a
// 100x100 grid and is never redrawn by eye -- every usage scales this same path data.
//
// variant: 'navy' for light/white backgrounds, 'reversed' for the dark navy ones. The
// center block is amber in both; only the brackets and wordmark change.
// layout:  'horizontal' is the full lockup with the wordmark, 'mark' is the mark alone.
// size:    the mark's rendered height in px; the lockup's width follows from it.

const NAVY = '#0D1B2A';
const AMBER = '#F5A623';
const WHITE = '#FFFFFF';

// Width of the horizontal lockup's viewBox, mark included, from the brand asset spec.
const LOCKUP_ASPECT = 540.36 / 100;

function Brackets({ stroke }) {
  return (
    <>
      <path d="M7 38 L7 7 L38 7" fill="none" stroke={stroke} strokeWidth={14} strokeLinejoin="miter" />
      <path d="M93 62 L93 93 L62 93" fill="none" stroke={stroke} strokeWidth={14} strokeLinejoin="miter" />
      <rect x={34} y={34} width={32} height={32} rx={4} fill={AMBER} />
    </>
  );
}

export default function VocationWorksLogo({ variant = 'navy', layout = 'horizontal', size = 36, className, style }) {
  const reversed = variant === 'reversed';
  const stroke = reversed ? WHITE : NAVY;

  if (layout === 'mark') {
    return (
      <svg viewBox="0 0 100 100" width={size} height={size} role="img" aria-label="Vocation Works"
           className={className} style={{ display: 'block', flexShrink: 0, ...style }}>
        <Brackets stroke={stroke} />
      </svg>
    );
  }

  // Below 16px the amber wordmark goes muddy on low-quality screens, so the spec sets the
  // whole wordmark solid at that size. The mark's center block stays amber either way.
  const worksFill = size < 16 ? stroke : AMBER;

  return (
    <svg viewBox={`0 0 ${LOCKUP_ASPECT * 100} 100`} width={size * LOCKUP_ASPECT} height={size}
         role="img" aria-label="Vocation Works" className={className}
         style={{ display: 'block', flexShrink: 0, ...style }}>
      <Brackets stroke={stroke} />
      <text x={130} y={68.8} fontFamily="'DM Sans', Arial, sans-serif" fontWeight={500} fontSize={55} letterSpacing="-0.2px">
        <tspan fill={stroke}>Vocation</tspan>
        <tspan fill={worksFill}> Works</tspan>
      </text>
    </svg>
  );
}
